export default __webpack_public_path__ + "static/media/login_bg_dark.b28a42f1.jpg";